import { render, staticRenderFns } from "./ProjectVisaDetails.vue?vue&type=template&id=4db6f608&"
import script from "./ProjectVisaDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectVisaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports